import { baseServerUrl } from "../utils/constant";
import { defineUrlIcon } from "../utils/defineUrlIcon";
export var IconArchiveFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArchiveFilled.svg")
});
export var IconArchiveOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArchiveStroked.svg")
});
export var IconArrowsDownLeft = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArrow2DownLeft.svg")
});
export var IconArrowsDownRight = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArrow2DownRight.svg")
});
export var IconArrowsUpLeft = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArrow2UpLeft.svg")
});
export var IconArrowsUpRight = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArrow2UpRight.svg")
});
export var IconArrowsDown = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArrow1Down.svg")
});
export var IconArrowsLeft = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArrow1Left.svg")
});
export var IconArrowsRight = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArrow1Right.svg")
});
export var IconArrowsUp = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconArrow1Up.svg")
});
export var IconBagFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBagFilled.svg")
});
export var IconBagOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBagStroked.svg")
});
export var IconBankFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBankFilled.svg")
});
export var IconBankOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBankOutline.svg")
});
export var IconBanRoundFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBanRoundFilled.svg")
});
export var IconBanRoundOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBanRoundStroked.svg")
});
export var IconBasketFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBasketFilled.svg")
});
export var IconBasketOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBasketStroked.svg")
});
export var IconBellFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBellFilled.svg")
});
export var IconBellOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBellStroked.svg")
});
export var IconBookFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBookFilled.svg")
});
export var IconBookOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBookOutline.svg")
});
export var IconBookmarkFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBookmarkFilled.svg")
});
export var IconBookmarkOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBookmarkStroked.svg")
});
export var IconBrokenHeartFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBrokenHeartFilled.svg")
});
export var IconBrokenHeartOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBrokenHeartStroked.svg")
});
export var IconBurgerMenu = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBurgerMenu.svg")
});
export var IconBusFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBusFilled.svg")
});
export var IconBusOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconBusOutline.svg")
});
export var IconCalculatorFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCalculatorFilled.svg")
});
export var IconCalculatorOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCalculatorStroked.svg")
});
export var IconCalendarFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCalendarFilled.svg")
});
export var IconCalendarOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCalendarStroked.svg")
});
export var IconCallSilentFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCallSilentFilled.svg")
});
export var IconCallSilentOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCallSilentStroked.svg")
});
export var IconCallingFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCallingFilled.svg")
});
export var IconCallingFilled1 = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCallingTrue1.svg")
});
export var IconCallingOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCallingStroked.svg")
});
export var IconCallingOutline1 = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCallingFalse1.svg")
});
export var IconCallingOnCrossedFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCallingOnCrossedFilled.svg")
});
export var IconCallingOnCrossedOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCallingOnCrossedOutline.svg")
});
export var IconCameraFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCameraFilled.svg")
});
export var IconCameraOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCameraStroked.svg")
});
export var IconCarFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCarFilled.svg")
});
export var IconCarOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCarOutline.svg")
});
export var IconCardFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCardFilled.svg")
});
export var IconCardOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCardStroked.svg")
});
export var IconCaseFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCaseFilled.svg")
});
export var IconCaseOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCaseStroked.svg")
});
export var IconCashFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCashFilled.svg")
});
export var IconCashOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCashOutline.svg")
});
export var IconChartAltFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChartAltFilled.svg")
});
export var IconChartAltOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChartAltStroked.svg")
});
export var IconChartFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChartFilled.svg")
});
export var IconChartOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChartStroked.svg")
});
export var IconChatAddMessageFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChatAddMessageFilled.svg")
});
export var IconChatAddMessageOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChatAddMessageStroked.svg")
});
export var IconChatMessageFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChatMessageFilled.svg")
});
export var IconChatMessageOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChatMessageStroked.svg")
});
export var IconChatPlusMessageFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChatPlusMessageFilled.svg")
});
export var IconChatPlusMessageOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChatPlusMessageStroked.svg")
});
export var IconCheckFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckFilled.svg")
});
export var IconCheckMarkCheck = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckMark1.svg")
});
export var IconCheckMarkDoubleCheck = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckMark2.svg")
});
export var IconCheckOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckStroked.svg")
});
export var IconCheckRoundFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckRoundFilled.svg")
});
export var IconCheckRoundOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckRoundStroked.svg")
});
export var IconCheckShieldFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckShieldFilled.svg")
});
export var IconCheckShieldOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckShieldStroked.svg")
});
export var IconCheckSquareFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckSquareFilled.svg")
});
export var IconCheckSquareOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCheckSquareStroked.svg")
});
export var IconChevronDown = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChevronDown.svg")
});
export var IconChevronLeft = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChevronLeft.svg")
});
export var IconChevronRight = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChevronRight.svg")
});
export var IconChevronUp = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconChevronUp.svg")
});
export var IconCloseRoundFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCloseRoundFilled.svg")
});
export var IconCloseRoundOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCloseRoundOutline.svg")
});
export var IconCloseRoundStroked = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCloseRoundStroked.svg")
});
export var IconCloseShieldFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCloseShieldFilled.svg")
});
export var IconCloseShieldOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCloseShieldStroked.svg")
});
export var IconCloseSquareFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCloseSquareFilled.svg")
});
export var IconCloseSquareOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCloseSquareStroked.svg")
});
export var IconCloudFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCloudFilled.svg")
});
export var IconCloudOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCloudOutline.svg")
});
export var IconCoinsFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCoinsFilled.svg")
});
export var IconCoinsOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCoinsStroked.svg")
});
export var IconCollapse = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCollapse.svg")
});
export var IconCompasFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCompasFilled.svg")
});
export var IconCompasOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCompasStroked.svg")
});
export var IconCopyFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCopyFilled.svg")
});
export var IconCopyOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCopyStroked.svg")
});
export var IconGadget = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconGadget.svg")
});
export var IconConnection = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconConnection.svg")
});
export var IconCouponFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCouponFilled.svg")
});
export var IconCouponOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconCouponStroked.svg")
});
export var IconDangerFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDangerFilled.svg")
});
export var IconDangerOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDangerStroked.svg")
});
export var IconDeskFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDeskFilled.svg")
});
export var IconDeskOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDeskStroked.svg")
});
export var IconDeskCrossedFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDeskCrossedFilled.svg")
});
export var IconDeskCrossedOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDeskCrossedOutline.svg")
});
export var IconDocFillFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDocFillFilled.svg")
});
export var IconDocFillOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDocFillStroked.svg")
});
export var IconDotsMessage2Filled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDotsMessage2Filled.svg")
});
export var IconDotsMessage2Outline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDotsMessage2Stroked.svg")
});
export var IconDotsMessageFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDotsMessageFilled.svg")
});
export var IconDotsMessageOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDotsMessageStroked.svg")
});
export var IconDotsRoundFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDotsRoundFilled.svg")
});
export var IconDotsRoundOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDotsRoundOutline.svg")
});
export var IconDotsRoundStroked = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDotsRoundStroked.svg")
});
export var IconDoubleRightArrowFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDoubleRightArrowFilled.svg")
});
export var IconDoubleRightArrowOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconDoubleRightArrowOutline.svg")
});
export var IconEditPencilFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconEditPencilFilled.svg")
});
export var IconEditPencilOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconEditPencilStroked.svg")
});
export var IconEsimFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconEsimFilled.svg")
});
export var IconEsimOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconEsimStroked.svg")
});
export var IconExpand = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconExpand.svg")
});
export var IconExportFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconExportFilled.svg")
});
export var IconExportOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconExportStroked.svg")
});
export var IconEyeCloseFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconEyeCloseFilled.svg")
});
export var IconEyeCloseOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconEyeCloseStroked.svg")
});
export var IconEyeOpenFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconEyeOpenFilled.svg")
});
export var IconEyeOpenOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconEyeOpenStroked.svg")
});
export var IconFaceIDFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFaceIDFilled.svg")
});
export var IconFaceIDOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFaceIDOutline.svg")
});
export var IconFileEmptyFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFileEmptyFilled.svg")
});
export var IconFileEmptyOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFileEmptyStroked.svg")
});
export var IconFileFillFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFileFillFilled.svg")
});
export var IconFileFillOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFileFillStroked.svg")
});
export var IconFingerprintFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFingerprintFilled.svg")
});
export var IconFingerprintStroked = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFingerprintStroked.svg")
});
export var IconFireFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFireFilled.svg")
});
export var IconFireOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFireStroked.svg")
});
export var IconFlagFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFlagFilled.svg")
});
export var IconFlagOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconFlagStroked.svg")
});
export var IconGamepadFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconGamepadFilled.svg")
});
export var IconGamepadOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconGamepadStroked.svg")
});
export var IconGiftFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconGiftFilled.svg")
});
export var IconGiftOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconGiftStroked.svg")
});
export var IconGlobeFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconGlobeFilled.svg")
});
export var IconGlobeOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconGlobeStroked.svg")
});
export var IconHeadphonesFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHeadphonesFilled.svg")
});
export var IconHeadphonesOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHeadphonesStroked.svg")
});
export var IconHeartFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHeartFilled.svg")
});
export var IconHeartOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHeartStroked.svg")
});
export var IconHomeFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHomeFilled.svg")
});
export var IconHomeOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHomeStroked.svg")
});
export var IconHoneyCombFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHoneyCombFilled.svg")
});
export var IconHoneyCombOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHoneyCombOutline.svg")
});
export var IconHoneyCombStyled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHoneyCombStyled.svg"),
  multiColor: false
});
export var IconHoneycombsFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHoneycombsFilled.svg")
});
export var IconHoneycombsOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHoneycombsStroked.svg")
});
export var IconHotelFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHotelFilled.svg")
});
export var IconHotelOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconHotelOutline.svg")
});
export var IconIPhoneFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconIPhoneFilled.svg")
});
export var IconIPhoneOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconIPhoneStroked.svg")
});
export var IconImageBoxFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconImageBoxFilled.svg")
});
export var IconImageBoxOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconImageBoxStroked.svg")
});
export var IconImportFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconImportFilled.svg")
});
export var IconImportOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconImportOutline.svg")
});
export var IconInfinite = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconInfinite.svg")
});
export var IconInfoFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconInfoFilled.svg")
});
export var IconInfoOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconInfoStroked.svg")
});
export var IconKeySquareFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconKeySquareFilled.svg")
});
export var IconKeySquareOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconKeySquareStroked.svg")
});
export var IconKeyboardFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconKeyboardFilled.svg")
});
export var IconKeyboardOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconKeyboardOutline.svg")
});
export var IconLableFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLableFilled.svg")
});
export var IconLableOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLableStroked.svg")
});
export var IconLayersFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLayersFilled.svg")
});
export var IconLayersOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLayersStroked.svg")
});
export var IconLeftArrowFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLeftArrowFilled.svg")
});
export var IconLeftArrowOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLeftArrowOutline.svg")
});
export var IconLightningCrossedOutFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLightningTrue1.svg")
});
export var IconLightningCrossedOutOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLightningFalse1.svg")
});
export var IconLightningFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLightningFilled.svg")
});
export var IconLightningOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLightningStroked.svg")
});
export var IconLoading = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLoading.svg")
});
export var IconLockCheckFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLockCheckFilled.svg")
});
export var IconLockCheckOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLockCheckStroked.svg")
});
export var IconLockCloseFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLockCloseFilled.svg")
});
export var IconLockCloseOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLockCloseStroked.svg")
});
export var IconLockFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLockFilled.svg")
});
export var IconLockOpenFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLockOpenFilled.svg")
});
export var IconLockOpenOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLockOpenStroked.svg")
});
export var IconLockOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLockStroked.svg")
});
export var IconLoginFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLoginFilled.svg")
});
export var IconLoginOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLoginStroked.svg")
});
export var IconLogoutFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLogoutFilled.svg")
});
export var IconLogoutOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconLogoutStroked.svg")
});
export var IconMailNewFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMailNewFilled.svg")
});
export var IconMailNewOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMailNewStroked.svg")
});
export var IconMailOpenFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMailOpenFilled.svg")
});
export var IconMailOpenOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMailOpenStroked.svg")
});
export var IconMarkFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMarkFilled.svg")
});
export var IconMarkOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMarkStroked.svg")
});
export var IconMicCrossedFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMicCrossedFilled.svg")
});
export var IconMicCrossedOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMicCrossedOutline.svg")
});
export var IconMicFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMicFilled.svg")
});
export var IconMicMuteFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMicMuteFilled.svg")
});
export var IconMicOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMicOutline.svg")
});
export var IconMicMuteOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMicMuteOutline.svg")
});
export var IconMinusRoundFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMinusRoundFilled.svg")
});
export var IconMinusRoundOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMinusRoundOutline.svg")
});
export var IconMinusRoundStroked = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMinusRoundStroked.svg")
});
export var IconMinusSquareFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMinusSquareFilled.svg")
});
export var IconMinusSquareOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMinusSquareStroked.svg")
});
export var IconMoonFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMoonFilled.svg")
});
export var IconMoonOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconMoonStroked.svg")
});
export var IconNotebookFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconNotebookFilled.svg")
});
export var IconNotebookOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconNotebookOutline.svg")
});
export var IconOrangeFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconOrangeFilled.svg")
});
export var IconOrangeStyled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconOrangeStyled.svg"),
  multiColor: false
});
export var IconPaperclip = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPaperclip.svg")
});
export var IconPassportFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPassportFilled.svg")
});
export var IconPassportOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPassportStroked.svg")
});
export var IconPercent = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPercent.svg")
});
export var IconPhoneCallInFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPhoneCallInFilled.svg")
});
export var IconPhoneCallInOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPhoneCallInOutline.svg")
});
export var IconPhoneCallOutFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPhoneCallOutFilled.svg")
});
export var IconPhoneCallOutOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPhoneCallOutOutline.svg")
});
export var IconPhoneCallTransferFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPhoneCallTransferFilled.svg")
});
export var IconPhoneCallTransferOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPhoneCallTransferOutline.svg")
});
export var IconPhoneFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPhoneFilled.svg")
});
export var IconPhoneOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPhoneStroked.svg")
});
export var IconPieChartFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPieChartFilled.svg")
});
export var IconPieChartOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPieChartStroked.svg")
});
export var IconPinFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPinFilled.svg")
});
export var IconPinOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPinStroked.svg")
});
export var IconPlaneFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPlaneFilled.svg")
});
export var IconPlaneOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPlaneOutline.svg")
});
export var IconPlayFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPlayFilled.svg")
});
export var IconPlayOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPlayStroked.svg")
});
export var IconPlusRoundFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPlusRoundFilled.svg")
});
export var IconPlusRoundOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPlusRoundStroked.svg")
});
export var IconPlusRoundStroked = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPlusRoundOutline.svg")
});
export var IconPlusSquareFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPlusSquareFilled.svg")
});
export var IconPlusSquareOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPlusSquareStroked.svg")
});
export var IconPowerFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPowerFilled.svg")
});
export var IconPowerOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPowerStroked.svg")
});
export var IconPumpFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPumpFilled.svg")
});
export var IconPumpOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconPumpOutline.svg")
});
export var IconQuestionFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconQuestionFilled.svg")
});
export var IconQuestionMessage3Filled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconQuestionMessage3Filled.svg")
});
export var IconQuestionMessage3Outline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconQuestionMessage3Stroked.svg")
});
export var IconQuestionMessageFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconQuestionMessageFilled.svg")
});
export var IconQuestionMessageOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconQuestionMessageStroked.svg")
});
export var IconQuestionOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconQuestionStroked.svg")
});
export var IconRainFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRainFilled.svg")
});
export var IconRainOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRainStroked.svg")
});
export var IconRefresh = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRefresh.svg")
});
export var IconRightArrowFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRightArrowFilled.svg")
});
export var IconRightArrowOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRightArrowOutline.svg")
});
export var IconRobotCrossedFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRobotCrossedFilled.svg")
});
export var IconRobotCrossedOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRobotCrossedOutline.svg")
});
export var IconRobotFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRobotFilled.svg")
});
export var IconRobotOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRobotStroked.svg")
});
export var IconRouterFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRouterFilled.svg")
});
export var IconRouterOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconRouterOutline.svg")
});
export var IconSaleCouponFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSaleCouponFilled.svg")
});
export var IconSaleCouponOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSaleCouponStroked.svg")
});
export var IconScannerQrFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconScannerQrFilled.svg")
});
export var IconScannerQrOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconScannerQrStroked.svg")
});
export var IconScreenMenu2Filled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconScreenMenu2Filled.svg")
});
export var IconScreenMenu2Outline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconScreenMenu2Stroked.svg")
});
export var IconScreenMenuFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconScreenMenuFilled.svg")
});
export var IconScreenMenuOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconScreenMenuStroked.svg")
});
export var IconSearchFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSearchFilled.svg")
});
export var IconSearchOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSearchStroked.svg")
});
export var IconSendFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSendFilled.svg")
});
export var IconSendOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSendStroked.svg")
});
export var IconSettings = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSettings.svg")
});
export var IconSettingsFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSettingsFilled.svg")
});
export var IconSettingsOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSettingsStroked.svg")
});
export var IconShareFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconShareFilled.svg")
});
export var IconShareOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconShareStroked.svg")
});
export var IconShieldFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconShieldFilled.svg")
});
export var IconShieldOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconShieldStroked.svg")
});
export var IconShoppingBagFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconShoppingBagFilled.svg")
});
export var IconShoppingBagOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconShoppingBagOutline.svg")
});
export var IconSimFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSimFilled.svg")
});
export var IconSimOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSimStroked.svg")
});
export var IconSoundFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSoundFilled.svg")
});
export var IconSoundOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSoundStroked.svg")
});
export var IconSpeedFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSpeedFilled.svg")
});
export var IconSpeedOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSpeedStroked.svg")
});
export var IconStarFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconStarFull.svg")
});
export var IconStarHalfFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconStarHalf.svg")
});
export var IconStarOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconStarNo.svg")
});
export var IconStopAndPlayFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconStopAndPlayFilled.svg")
});
export var IconStopAndPlayOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconStopAndPlayStroked.svg")
});
export var IconStopFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconStopFilled.svg")
});
export var IconStopOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconStopStroked.svg")
});
export var IconStudyFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconStudyFilled.svg")
});
export var IconStudyOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconStudyOutline.svg")
});
export var IconSunFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSunFilled.svg")
});
export var IconSunOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSunStroked.svg")
});
export var IconSwap = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconSwap.svg")
});
export var IconTabletFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTabletFilled.svg")
});
export var IconTabletOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTabletOutline.svg")
});
export var IconTimeFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTimeFilled.svg")
});
export var IconTimeOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTimeStroked.svg")
});
export var IconToolFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconToolFilled.svg")
});
export var IconToolOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconToolOutline.svg")
});
export var IconTrashFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTrashFilled.svg")
});
export var IconTrashOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTrashStroked.svg")
});
export var IconTrainFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTrainFilled.svg")
});
export var IconTrainOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTrainOutline.svg")
});
export var IconTvFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTvFilled.svg")
});
export var IconTvOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconTvOutline.svg")
});
export var IconUserAddFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconUserAddFilled.svg")
});
export var IconUserAddOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconUserAddStroked.svg")
});
export var IconUserFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconUserFilled.svg")
});
export var IconUserOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconUserStroked.svg")
});
export var IconUsersGroupFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconUsersGroupFilled.svg")
});
export var IconUsersGroupOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconUsersGroupStroked.svg")
});
export var IconVideoFileFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconVideoFileFilled.svg")
});
export var IconVideoFileOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconVideoFileStroked.svg")
});
export var IconVideoFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconVideoFilled.svg")
});
export var IconVideoOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconVideoStroked.svg")
});
export var IconVolumeOffFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconVolumeOffFilled.svg")
});
export var IconVolumeOffOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconVolumeOffStroked.svg")
});
export var IconVolumeUpFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconVolumeUpFilled.svg")
});
export var IconVolumeUpOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconVolumeUpStroked.svg")
});
export var IconWalletFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconWalletFilled.svg")
});
export var IconWalletOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconWalletStroked.svg")
});
export var IconWatchFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconWatchFilled.svg")
});
export var IconWatchOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconWatchOutline.svg")
});
export var IconWifi2Filled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconWifi2Filled.svg")
});
export var IconWifi2Outline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconWifi2Outline.svg")
});
export var IconWifiFilled = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconWifiFilled.svg")
});
export var IconWifiOutline = defineUrlIcon({
  url: "".concat(baseServerUrl, "/icons/IconWifiOutline.svg")
});